import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TituloComponent } from '../../titulo/titulo.component';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
// import { ItemsService } from '../../../../services/items.service';
import { StrapiService } from '../../../../services/strapi.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-pagina',
  templateUrl: './pagina.component.html',
  styleUrls: ['./pagina.component.scss']
})
export class PaginaComponent implements OnInit {

  datas:any=[];
  data:any;
  myDatas:any=[];
  myData:any;
  totalLength:any;
  errores:string="";

  //id = 0;
  id:number;
  novedades: Object;
  sharebuttons: string;
  categories: Object;
  topnews: Object;
  currenturl: string;
  current_url: any;

  constructor( private activatedRoute: ActivatedRoute,
               private router: Router,
  			       public strapiserv:StrapiService ,
               private http: HttpClient,
               private domSanitizer: DomSanitizer,
  	){ 

  	// this.activatedRoute.params.subscribe( params => {
  	// 	this.item = this.strapiserv.getData( params['id'] );
  	// });

    }

  ngOnInit(): void {
    this.currenturl=window.location.href;
    this.id=this.activatedRoute.snapshot.params.id;
    this.http.get(`${environment.apiurl}posts?_embed&slug=`+ this.activatedRoute.snapshot.params.slug).subscribe(data =>{
      this.datas=data;
      console.log(this.datas);
      this.current_url=this.domSanitizer.bypassSecurityTrustResourceUrl(this.datas[0].guid.rendered);
      this.findNews();
    })
    this.http.get(`${environment.apiurl}categories`).subscribe(data =>{
      this.categories=data;
    })
    this.http.get(`${environment.apiurl}posts?_embed&per_page=3`).subscribe(data =>{
      this.topnews=data;
    })
  }
  findNews(){
    this.http.get(`${environment.apiurl}posts?categories=` + this.datas[0].categories[0] + `&per_page=3`).subscribe(data =>{
      this.novedades=data;
    })
  }
  reload(info:any){
    this.http.get(`${environment.apiurl}posts?_embed&slug=`+info).subscribe(data =>{
      this.datas=data;
    })
  }

}
 
 